import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditCodeSnippetDialogComponent } from './edit-dialog/edit-code-snippet-dialog.component';

@Component({
    selector: 'code-snippets',
    templateUrl: './code-snippets.component.html',
    styleUrls: ['./code-snippets.component.scss'],
    standalone: false
})
export class CodeSnippetsContentComponent implements OnInit {
  @Input() dynamicContent;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
    if (!this.dynamicContent.content.codeSnippets) {
      this.dynamicContent.content.codeSnippets = [];
    }
  }

  async editCodeSnippet(index?: number) {
    const data = { index: index, data: JSON.parse(JSON.stringify(this.dynamicContent.content.codeSnippets)) };
    const codeSnippet: any = await this.dialog.open(EditCodeSnippetDialogComponent, { width: '800px', data }).afterClosed().toPromise();
    if (!codeSnippet) {
      return;
    }
    if (this.dynamicContent.content.codeSnippets[index]) {
      this.dynamicContent.content.codeSnippets[index] = codeSnippet;
    } else {
      this.dynamicContent.content.codeSnippets.push(codeSnippet);
    }
  }

  removeCodeSnippet(index: number) {
    this.dynamicContent.content.codeSnippets.splice(index, 1);
  }
}
